module.exports = __webpack_public_path__ + "static/media/DO.3bb1ef6d.svg";